import Loader from "src/components/Loader";
import ApplicationsTable from "src/components/tables/ApplicationsTable";
import Actions from "src/components/Actions";
import {useGET} from "src/hooks/useApi";
import Application from "src/types/Application.type";
import Config from "../../../classes/application/Config";
import {Applicationx} from "../../../classes/Application";

const ListApplicationReceived = () => {
    let {data, isLoading, error} = useGET<Application[]>(
        "account/company/applications_received"
    );

    let cfg = Config.getInstance();
    let app = Applicationx.getInstance();
    if (cfg.hasProgressiveRegister() && !app.hasCompany()) {
        data=[];
        return (<>
                <Actions
                    title="cvs_received"
                    infoboxCode="infobox_cvs_received"
                />
                <ApplicationsTable data={data}/>
            </>
        );
    }


    return (
        <Loader isLoading={isLoading} error={error} hasData={!!data}>
            <Actions
                title="cvs_received"
                infoboxCode="infobox_cvs_received"
            />
            <ApplicationsTable data={data}/>
        </Loader>
    );
};

export default ListApplicationReceived;
